import React from 'react';
import PropTypes from 'prop-types';

// to use custom icons, copy the SVG to the svg object below
// https://tabler-icons.io/

// example usage:
// <Icon name="calendar" className="mr-3" />

const Icon = ({ name, className }) => {
    if (!svgs[name]) {
        return <span className="text-red-400">Cannot Find Icon</span>
    }

    return (
        <svg xmlns="http://www.w3.org/2000/svg" className={['h-4 mb-0.5', className].join(' ')} viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
            {svgs[name]}
        </svg>
    )
};

export default Icon;

Icon.defaultProps = {
    className: '',
};

Icon.propTypes = {
    name: PropTypes.string.isRequired,
    className: PropTypes.string,
};


const svgs = {
    file: (
        <>
            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
            <path d="M14 3v4a1 1 0 0 0 1 1h4"></path>
            <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"></path>
        </>
    ),
    'user-check': (
        <>
            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"></path>
            <path d="M16 11l2 2l4 -4"></path>
        </>
    ),
    dollar: (
        <>
            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
            <path d="M16.7 8a3 3 0 0 0 -2.7 -2h-4a3 3 0 0 0 0 6h4a3 3 0 0 1 0 6h-4a3 3 0 0 1 -2.7 -2"></path>
            <path d="M12 3v3m0 12v3"></path>
        </>
    ),
    calendar: (
        <>
           <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
            <rect x="4" y="5" width="16" height="16" rx="2"></rect>
            <line x1="16" y1="3" x2="16" y2="7"></line>
            <line x1="8" y1="3" x2="8" y2="7"></line>
            <line x1="4" y1="11" x2="20" y2="11"></line>
            <line x1="11" y1="15" x2="12" y2="15"></line>
            <line x1="12" y1="15" x2="12" y2="18"></line>
        </>
    ),
    clock: (
        <>
            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
            <circle cx="12" cy="12" r="9"></circle>
            <polyline points="12 7 12 12 15 15"></polyline>
        </>
    ),
    building: (
        <>
            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
            <line x1="3" y1="21" x2="21" y2="21"></line>
            <path d="M5 21v-14l8 -4v18"></path>
            <path d="M19 21v-10l-6 -4"></path>
            <line x1="9" y1="9" x2="9" y2="9.01"></line>
            <line x1="9" y1="12" x2="9" y2="12.01"></line>
            <line x1="9" y1="15" x2="9" y2="15.01"></line>
            <line x1="9" y1="18" x2="9" y2="18.01"></line>
        </>
    )
}

